import { useSyncModalStore } from '@register-ui/utils';
import { RegisterSetup } from '../register-setup';

export function SyncModalPortal() {
    const { isOpen, syncError, syncPercentage, onResume, dismiss } =
        useSyncModalStore();

    return (
        <RegisterSetup
            isOpen={isOpen}
            onClose={dismiss}
            syncPercentage={syncPercentage}
            syncError={syncError}
            onResume={onResume ?? undefined}
        />
    );
}
